import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty"; /**
                                                                                                                                                       * 组件demo
                                                                                                                                                       **/
import React from 'react';
import { parse } from '../../../utils/commonUtilFunc';
var MI0103 = /*#__PURE__*/function (_React$Component) {
  _inherits(MI0103, _React$Component);
  function MI0103(props) {
    var _this;
    _classCallCheck(this, MI0103);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MI0103).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_tunnel_port", function () {
      _this.props.dispatch({
        type: "mi0103Info/get_tunnel_port",
        payload: {
          sn: parse(_this.props.location.search).sn
        }
      });
    });
    _this.state = {};
    return _this;
  }
  _createClass(MI0103, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_tunnel_port();
      localStorage.removeItem("go_default_prefs");
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          backGroundColor: "#000"
        }
      }, /*#__PURE__*/React.createElement("div", {
        id: "gateone_container",
        style: {
          width: document.body.clientWidth,
          height: document.body.clientHeight,
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement("div", {
        id: "gateone",
        style: {
          width: document.body.clientWidth,
          height: document.body.clientHeight
        }
      })));
    }
  }]);
  return MI0103;
}(React.Component);
export default MI0103;